export const SUPPORT_MAIL_NAME = 'support';
export const PARTNER_MAIL_NAME = 'partner';

export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME;
export const HOST_NAME = process.env.REACT_APP_HOST_NAME;
export const ORIGIN = process.env.REACT_APP_ORIGIN;
export const E_MAIL_DOMAIN = process.env.REACT_APP_E_MAIL_DOMAIN;

export const toEmailWithDomain = localPart => `${localPart}@${E_MAIL_DOMAIN}`;
